module.exports = __webpack_public_path__ + "static/media/sign_out.f9dc869d.svg";